<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        If the
        <stemble-latex content="$\text{pH}$" />
        of an aqueous solution is
        <number-value :value="pH" />, then the
        <chemical-latex content="H+" />
        concentration is:
      </p>

      <calculation-input
        v-model="inputs.input1"
        prepend-text="$\ce{[H+]}:$"
        append-text="$\text{M}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'ChemOleMiss116PL7Q4',
  components: {
    StembleLatex,
    ChemicalLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    pH() {
      return this.taskState.getValueBySymbol('pH').content;
    },
  },
};
</script>
